// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module__banner___3hBFl","navy":"Banner-module__navy___6TdOX","lightblue":"Banner-module__lightblue___36E8a","paleblue":"Banner-module__paleblue___1B-DX"};